import { useEffect, useState } from "react";
import { webUrlNode } from "../../constants/appInfo";
import { useSelector } from "react-redux";
import CreditRechargePanel from "./CreditRechargePanel";

import ItemUsageUI from "./Components/ItemUsageUI";
import ItemWalletUI from "./Components/ItemWalletUI";

export default function TenantSMSCreditDashboard() {

         const userId = useSelector((state)=>state?.user?.user?.user_id)
const currentToken = useSelector((state)=>state?.user?.user?.token);
          const appToken = useSelector((state)=>state?.app?.app?.AppToken);
 
       
const [tenantId,setTenantId] =useState(userId)
  const [wallet, setWallet] = useState(null);
  const [usage, setUsage] = useState([]);
const [rows, setRows] = useState([]);

  const [useCase, setUseCase] = useState(null);
  const [toSMS, setToSMS] = useState(null);
  const [from, setFrom] = useState(null);
  const [to, setTo] = useState(null);
  const [status, setStatus] = useState("created");

  const [loading, setLoading] = useState(false);

 const params = new URLSearchParams({
      channel: "sms",
      ...(useCase ? { useCase } : {}),
      ...(toSMS ? { toSMS } : {}),
      ...(from ? { from } : {}),
      ...(to ? { to } : {}),
      ...(status?{status}:{}),
      limit: 50,tenantId,appToken,currentToken
    });
  useEffect(() => {
    load();
  }, [useCase,toSMS,from,to]);
  
  async function load() {
    setLoading(true);


    const w = await fetch(
      `${webUrlNode}/api/credits/wallet?channel=sms&tenantId=${tenantId}&appToken=${appToken}&currentToken=${currentToken}`,
      
    ).then(r => r.json());

    const u = await fetch(
      `${webUrlNode}/api/credits/usage?${params.toString()}`,
      
    ).then(r => r.json());
   console.log(u)
    setWallet(w);
    setUsage(u || []);
   
    setLoading(false);
  }

  if (!wallet) return <div>Loading…</div>;

  return (
   <>
   
   <ItemWalletUI
     wallet ={wallet}
     title={"Sms Wallet"}
    
    
    />
   
   <CreditRechargePanel channel={"sms"} />
   
   
    <ItemUsageUI
    title={"Sms Usage"}
    
     usage={usage}
     loading={loading}
     useCase={useCase}
     setUseCase={setUseCase}
     toEmail={toSMS}
     setToEmail={setToSMS}
     from={from}
     setFrom={setFrom}
     to={to}
     setTo={setTo}
     load={load}
    />
       
   </>
  );
}
